import boxAttachment from "./boxAttachment.vue";
export default boxAttachment;
